import React, { useCallback, useEffect, useRef, useState } from 'react';
import { Button, Dialog, DialogContent, DialogTitle, TextField, Grid, DialogActions, Autocomplete, ListItem, ListItemText, debounce, Typography } from '@mui/material';
import { useFormik } from 'formik';
import * as yup from 'yup';
import { Stack } from '@mui/system';
export function AddVendedorDialog({ CrmService, onClose, title, ...props }) {
    // AutoComplete
    const [loadAutoComplete, setLoadAutoComplete] = useState(false);
    const [options, setOptions] = useState([]);
    const [inputValue, setInputValue] = useState('');
    const [page, setPage] = useState(0);
    const [hasMore, setHasMore] = useState(true);
    const [loadingIds, setLoadingIds] = useState(true);
    const noFetchRef = useRef([]); // contactos já associados, não pesquisar os mesmos
    const limit = 10; // Número de itens por página
    const [funcionario, setFuncionario] = useState(null);
    const validationSchema = yup.object({
        funcionarioId: yup
            .number()
            .nullable()
            .typeError('Preenchimento Obrigatório') // Garante que um número válido seja informado
            .required('Preenchimento Obrigatório')
    });
    const formik = useFormik({
        initialValues: {
            funcionarioId: null
        },
        validationSchema,
        validateOnChange: false,
        onSubmit: values => {
            onClose(values.funcionarioId);
        }
    });
    const getIdVendedores = async () => {
        try {
            setLoadingIds(true); // 🔹 Marca que estamos carregando os IDs
            let ids = await CrmService.getIdVendedores(); // Obtém os IDs dos vendedores atuais
            if (Array.isArray(ids)) {
                noFetchRef.current = ids; // Atualiza a referência
            }
            else {
                console.warn("getIdVendedores não retornou um array válido");
            }
        }
        catch (error) {
            console.log("Erro ao obter Id's dos Vendedores", error);
        }
        finally {
            setLoadingIds(false); // 🔹 Marca que terminamos de carregar os IDs
        }
    };
    const fetchOptions = useCallback(debounce(async (query, currentPage) => {
        if (!query || !hasMore || loadingIds)
            return;
        setLoadAutoComplete(true);
        try {
            const response = await CrmService.funcionarioAutocomplete(query, currentPage, limit, noFetchRef.current);
            if (response.length < limit) {
                setHasMore(false); // Não há mais dados
            }
            setOptions(prev => [...prev, ...response]); // Concatena os dados
        }
        catch (error) {
            console.error('Erro ao carregar opções:', error);
        }
        finally {
            setLoadAutoComplete(false);
        }
    }, 500), [hasMore, loadingIds] // Atualiza se `hasMore` mudar
    );
    const handleScroll = event => {
        const listboxNode = event.currentTarget;
        if (listboxNode.scrollTop + listboxNode.clientHeight >= listboxNode.scrollHeight - 1 && !loadAutoComplete && hasMore) {
            setPage(prev => prev + 1); // Incrementa a página
        }
    };
    useEffect(() => {
        getIdVendedores();
    }, []);
    // AutoComplete
    useEffect(() => {
        if (inputValue) {
            fetchOptions(inputValue, page);
        }
    }, [inputValue, page]);
    return (<Dialog {...props} fullWidth maxWidth='lg' onClose={() => onClose(null)}>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <Grid container spacing={2} sx={{ mt: 1 }}>
          <Grid item xs={12} md={12} lg={12}>
            <Autocomplete disablePortal={false} // lista não fica dentro da dialog
     options={options} getOptionLabel={option => (option.name ? `${option.name}` : '')} value={funcionario || null} // O valor completo da opção selecionada
     onChange={(event, newValue) => {
            setFuncionario(newValue);
            formik.setFieldValue('funcionarioId', newValue ? newValue.id : null);
            formik.setTouched({ funcionarioId: false });
        }} loading={loadAutoComplete} noOptionsText='Pesquise pelo nome do Colaborador' loadingText='A carregar colaboradores ...' 
    //filterOptions={x => x} // Evita o filtro padrão
    onInputChange={(event, newInputValue, reason) => {
            if (reason !== 'reset') {
                setInputValue(newInputValue); // Só altera o input se for uma entrada do user
                setOptions([]);
                setPage(0);
                setHasMore(true);
            }
        }} ListboxProps={{
            onScroll: handleScroll // Adiciona evento de scroll
        }} renderOption={(props, option) => (<ListItem {...props} key={option.id} dense>
                  <ListItemText primary={option.name} secondary={<Stack direction='column'>
                        <Typography variant='caption'>Email: {option.email ?? 'Sem email'}</Typography>
                        <Typography variant='caption'>Nº Mecanográfico: {option.num ?? 'Não tem'}</Typography>
                      </Stack>}/>
                </ListItem>)} renderInput={params => (<TextField {...params} label='Contacto' variant='outlined' size='small' fullWidth error={formik.touched.funcionarioId && Boolean(formik.errors.funcionarioId)} helperText={formik.touched.funcionarioId ? formik.errors.funcionarioId || '' : ''}/>)}/>
          </Grid>
        </Grid>
      </DialogContent>

      <DialogActions sx={{ mt: 2 }}>
        <Button onClick={() => {
            formik.handleSubmit();
        }} variant='contained'>
          Adicionar
        </Button>
      </DialogActions>
    </Dialog>);
}
